import { useMutation } from '@tanstack/react-query'
import { postEstimate } from 'services/PaymentsService'

export const usePostEstimateMutation = () => {
  return useMutation({ mutationFn: postEstimate })
}
